import { ReferenceField } from 'react-admin'

import config from './config'
import AdvancedTextField from '../../components/AdvancedTextField'

const VehicleField = (props) => (
  <ReferenceField {...props}>
    <AdvancedTextField source="designation" />
  </ReferenceField>
)

VehicleField.defaultProps = {
  source: config.options.referenceKey,
  reference: config.name,
  link: 'show',
}

export default VehicleField
